import { FC } from 'react';
import * as stylex from '@stylexjs/stylex';
import { UsedForm } from '@pages/form-page/ui/used-form';
import { SminexEventIcon } from '@shared/assets/icons';
import { palette } from '@shared/tokens/palette.stylex';
import { styles } from '@pages/form-page/styles';

interface FormUsedFormWrapperProps {
  eventName: string;
  dateStart: string;
  dateEnd: string;
}

export const FormUsedFormWrapper: FC<FormUsedFormWrapperProps> = ({ eventName, dateStart, dateEnd }) => {
  return (
    <div translate="no" {...stylex.props(styles.containerBlack)}>
      <div {...stylex.props(styles.logoWrapper)}>
        <SminexEventIcon colorPrimary={palette.greyWhite} colorSecondary={palette['bronze-500']} />
      </div>
      <div {...stylex.props(styles.errorInviteContent)}>
        <UsedForm eventName={eventName} dateStart={dateStart} dateEnd={dateEnd} />
      </div>
    </div>
  );
};
